import { Grid, Button } from "@mui/material";

function CustomPagination({ pagination, onPageChange }) {
  const { currentPage, nextPage, prevPage } = pagination;
  const totalVisible = Math.min(pagination.totalPages, 5);

  let start = Math.max(1, currentPage - Math.floor(totalVisible / 2));
  let end = start + totalVisible - 1;

  if (currentPage <= Math.ceil(totalVisible / 2)) {
    start = 1;
    end = totalVisible;
  }

  const pageNumbers = [];
  for (let i = start; i <= end; i++) {
    pageNumbers.push(i);
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{ mt: 3 }}
    >
      {/* Previous Button */}
      <Button
        variant="text"
        disabled={!prevPage}
        onClick={() => onPageChange(prevPage)}
        sx={{
          color: !nextPage ? "#ccc" : "#000",
          textTransform: "none",
          fontFamily: "Inter",
          fontWeight: 400,
          fontStyle: "normal",
          fontSize: "18px",
          lineHeight: "100%",
          letterSpacing: 0,
          verticalAlign: "middle",
        }}
      >
        Previous
      </Button>

      <Grid item sx={{ display: "flex", mx: 2 }}>
        {pageNumbers.map((num) => (
          <Button
            key={num}
            onClick={() => onPageChange(num)}
            variant={num === currentPage ? "contained" : "text"}
            sx={{
              minWidth: "32px",
              height: "32px",
              margin: "0 4px",
              backgroundColor: num === currentPage ? "#FCE8F8" : "transparent",
              color: num === currentPage ? "#9D0385" : "#000",
              fontFamily: "Inter",
              fontWeight: num === currentPage ? 700 : 400,
              fontStyle: num === currentPage ? "bold" : "normal",
              fontSize: num === currentPage ? "20px" : "18px",
              lineHeight: "100%",
              letterSpacing: 0,
              verticalAlign: "middle",
              textTransform: "none",
              "&:hover": {
                backgroundColor:
                  num === currentPage ? "#FCE8F8" : "transparent",
                color: num === currentPage ? "#9D0385" : "#000",
              },
            }}
          >
            {num}
          </Button>
        ))}
      </Grid>

      <Button
        variant="text"
        disabled={!nextPage}
        onClick={() => onPageChange(nextPage)}
        sx={{
          color: !nextPage ? "#ccc" : "#000",
          textTransform: "none",
          fontFamily: "Inter",
          fontWeight: 400,
          fontStyle: "normal",
          fontSize: "18px",
          lineHeight: "100%",
          letterSpacing: 0,
          verticalAlign: "middle",
        }}
      >
        Next
      </Button>
    </Grid>
  );
}

export default CustomPagination;
